import { useApi } from './use-api-call';
import { UserDTO } from './user-api';


export const useSearchSysLogApi = () => useApi<{ 
sysLogs: SysLogDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/sys-log/search-sys-log');

export const useGetSysLogApi = () => useApi<{ sysLog: SysLogDTO; allowEdit: boolean; }>('/sys-log/get-sys-log/{serial}');

export const useSaveSysLogApi = () => useApi<{ sysLog: SysLogDTO}>('/sys-log/save-sys-log');

export const useDeleteSysLogApi = () => useApi('/sys-log/delete-sys-log/{serial}');

export interface SysLogDTO { 
serial?:number;
type:string;
message:string;
displayMessage:string;
details:string;
url:string;
queryString:string;
properties:string;
sessionId:number;
token:string;
userName:string;
createdAt?:Date;
}
